import { ILinkProps } from '@/pages/Checkout/types/paymentLinkContextTypes';

type ILink = ILinkProps | null | undefined;

export const isPaid = (link: ILink): boolean =>
  link?.status === 'paid' || Boolean(link?.paid_at);

export const isExpired = (link: ILink): boolean => link?.status === 'expired';

export const isSettled = (link: ILink): boolean =>
  isPaid(link) || isExpired(link);

export const hasFailedAttempt = (link: ILink): boolean =>
  link?.last_payment_link_intent?.payment_status === 'failed';

export const getInstallments = (link: ILink): number | undefined =>
  link?.payment_link_transaction?.installments ?? link?.installments;
